module.exports = __webpack_public_path__ + "static/media/WHallCorner.b96bb659.webp";